import React from "react";
import { Box, Typography, Container, Button } from "@mui/material";

const YouTubeKeywordSuggestContent = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Container maxWidth="md" sx={{ textAlign: "center", mt: 4 }}>
      {/* Introduction */}
      <Typography variant="h4" fontWeight="bold" sx={{ fontSize: "1.75rem" }} gutterBottom>
        Discover High-Traffic YouTube Keywords in Seconds
      </Typography>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Boost Visibility with Smarter Keyword Ideas
      </Typography>
      <Typography variant="body1" paragraph>
        Finding the right keywords is the key to growing your YouTube channel. But research can be time-consuming.
      </Typography>
      <Typography variant="body1" paragraph>
        Our YouTube Keyword Suggestion Tool helps you uncover trending, SEO-optimized keyword ideas instantly—so you can create content that gets noticed.
      </Typography>

      {/* Features */}
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Why Use the YouTube Keyword Suggestion Tool?
      </Typography>
      <ul style={{ textAlign: "left", display: "inline-block" }}>
        <li>🔍 AI-Powered Keyword Suggestions Based on Your Topic</li>
        <li>🚀 Alphabet Soup Strategy for Deep Keyword Expansion</li>
        <li>📊 Built-in Keyword Difficulty Scoring (Easy to Hard)</li>
        <li>📥 Copy or Download Keyword Lists as CSV</li>
        <li>🧠 Ideal for Video SEO: Titles, Tags, and Descriptions</li>
      </ul>

      {/* How It Works */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        How to Get YouTube Keyword Suggestions
      </Typography>
      <ol style={{ textAlign: "left", display: "inline-block" }}>
        <li>Log in to MyFreshTools and open the Keyword Suggestion tool.</li>
        <li>Enter your video idea, niche, or seed keyword.</li>
        <li>Click “Generate Keywords” to view a list of suggestions with difficulty scores.</li>
        <li>Copy or export the keywords to start planning your next video!</li>
      </ol>

      {/* FAQs */}
      <Typography variant="h5" fontWeight="bold" gutterBottom mt={4}>
        Frequently Asked Questions (FAQs)
      </Typography>

      <Typography variant="body1" fontWeight="bold">✨ How are these keywords generated?</Typography>
      <Typography variant="body2" paragraph>
        We use Google’s auto-suggest API and apply smart filters to eliminate brand names, duplicates, and irrelevant terms.
      </Typography>

      <Typography variant="body1" fontWeight="bold">📊 What does the Keyword Difficulty score mean?</Typography>
      <Typography variant="body2" paragraph>
        Each keyword is assigned a difficulty score based on its length, popularity patterns, and competitiveness—helping you choose the easiest opportunities to rank for.
      </Typography>

      <Typography variant="body1" fontWeight="bold">📋 Can I export the keyword list?</Typography>
      <Typography variant="body2" paragraph>
        Yes, you can copy all suggestions or download the list as a CSV with just one click.
      </Typography>

      <Typography variant="body1" fontWeight="bold">💡 Is this tool good for tags and video descriptions?</Typography>
      <Typography variant="body2" paragraph>
        Absolutely. Use these keyword ideas to optimize your titles, tags, and video descriptions for better visibility on YouTube.
      </Typography>

      {/* Call to Action */}
      <Box mt={4}>
        <Button variant="contained" color="primary" size="large" onClick={scrollToTop}>
          Start Generating Keywords
        </Button>
      </Box>
    </Container>
  );
};

export default YouTubeKeywordSuggestContent;
